/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__file_report__model__Status;

(function (jove__app__file_report__model__Status) {
  jove__app__file_report__model__Status["PENDING"] = "pending";
  jove__app__file_report__model__Status["STARTED"] = "started";
  jove__app__file_report__model__Status["COMPLETED"] = "completed";
  jove__app__file_report__model__Status["FAILED"] = "failed";
})(jove__app__file_report__model__Status || (jove__app__file_report__model__Status = {}));